import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const GUIDE_SRC = `${process.env.REACT_APP_BACKEND_URL}/api/guide`;

export default function Guide() {
  return (
    <div data-testid="guide-page">
      <Link
        to="/"
        data-testid="guide-back-home"
        style={{ position: "fixed", top: 16, left: 16, zIndex: 9999 }}
        className="inline-flex items-center gap-2 rounded-full bg-navy/90 text-white px-4 py-2.5 text-sm font-semibold shadow-lg backdrop-blur hover:bg-brand transition-colors"
      >
        <ArrowLeft size={16} /> Back to Home
      </Link>
      <iframe
        title="Alma Y Lengua Digital Services Guide"
        src={GUIDE_SRC}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          border: "none",
        }}
        allow="fullscreen"
      />
    </div>
  );
}
